import _jsx from "@babel/runtime/helpers/jsx";
var _Label, _HotCar, _NewlyListed, _ReducedPrice;
import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import { useBrand } from '@atc/brand';
import { Glyphicon, Label } from 'reaxl';
import { HotCar, NewlyListed, ReducedPrice } from 'reaxl-molecules';
import clsx from 'clsx';
import { useFeatures } from 'reaxl-features';
import InventoryListingSaveGlyph from '../InventoryListingSaveGlyph/index.js';

/*
 * InventoryListingOverlayActions is a layout component that handles the overlay actions
 * positioned over the inventory listing image.
 * For performance reasons this functionality is positioned relatively to the image via CSS
 * rather than using the PositionOverlay component.
 *
 * LANDSCAPE:
 * ,------------------- Image-- -
 * |  ---                  ---  |
 * | |Icon|               |Icon||
 * |  ---                  ---  |
 * |                            |
 * |                            |
 *  ----------------------------
 *
 * PORTRAIT:
 * ,----_--- Image-- -
 * |  ---       ---  |
 * | |Icon|    |Icon||
 * |  ---       ---  |
 * |                 |
 * |                 |
 * |                 |
 * |                 |
 *  -----------------
 */
function InventoryListingOverlayActions(_ref) {
  var _InventoryListingSave;
  let {
    onSaveToggle,
    listing,
    isSaved,
    show360,
    additionalCta,
    uiContext = 'default'
  } = _ref;
  const {
    isBrand
  } = useBrand();
  const isFord = isBrand('ford');
  const {
    compare: [, {
      disableSaveIcon
    }]
  } = useFeatures(['compare']);
  const hasAdditionalCta = /*#__PURE__*/isValidElement(additionalCta);
  const renderSnaplotIndicator = () => show360 && (_Label || (_Label = /*#__PURE__*/_jsx(Label, {
    bsStyle: "inverse",
    className: "margin-left-2"
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "degree-rotate",
    className: "text-size-200"
  }), /*#__PURE__*/_jsx("span", {
    className: "sr-only"
  }, void 0, "360\xB0 Virtual Tour"))));
  const renderInventoryListingSaveGlyph = () => onSaveToggle && (_InventoryListingSave || (_InventoryListingSave = /*#__PURE__*/_jsx(InventoryListingSaveGlyph, {
    listing: listing,
    onSaveToggle: onSaveToggle,
    uiContext: "accent-circle",
    isSaved: isSaved
  })));
  const renderCompareAndSave = () => onSaveToggle && renderInventoryListingSaveGlyph();
  const renderBadge = () => {
    const {
      isNewlyListed,
      isReducedPrice,
      isHot
    } = listing;
    if (isHot && uiContext !== 'snapshot') {
      return _HotCar || (_HotCar = /*#__PURE__*/_jsx(HotCar, {}));
    }
    if (isNewlyListed) {
      return _NewlyListed || (_NewlyListed = /*#__PURE__*/_jsx(NewlyListed, {}));
    }
    if (isReducedPrice) {
      return _ReducedPrice || (_ReducedPrice = /*#__PURE__*/_jsx(ReducedPrice, {
        label: "Recent Price Drop"
      }));
    }
    return null;
  };
  const isSnapshot = uiContext === 'snapshot';
  const badgeClassName = clsx('overlay-glyphs col-xs-8 display-flex align-items-center', {
    'padding-left-1 padding-right-0': isSnapshot
  });
  const iconClassName = clsx('overlay-glyphs display-flex align-items-center justify-content-end', {
    'padding-left-0 padding-right-1': isSnapshot,
    'col-xs-4 margin-top-2': !hasAdditionalCta,
    'col-xs-12 margin-top-4 padding-right-4': hasAdditionalCta
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hasAdditionalCta && /*#__PURE__*/_jsx("div", {
    className: badgeClassName
  }, void 0, !isFord && renderBadge(listing), renderSnaplotIndicator()), /*#__PURE__*/_jsx("div", {
    className: iconClassName
  }, void 0, hasAdditionalCta && additionalCta, !disableSaveIcon && renderCompareAndSave()));
}
export default InventoryListingOverlayActions;